import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { useAppData } from 'src/app/data';
import { RouteComponentProps } from 'src/router/types';
import { MenuItem } from 'src/components/navigation';
import { useContainerNavigationProps } from 'src/hooks/use-container-navigation-props';
import { useNavigationData } from 'src/hooks/use-navigation-data';
import { getRouteFeaturesFromAppData } from 'src/router/utils';
import Navigation, {
  useLegacyReduxNavigationData,
} from 'src/sections/global/containers/navigation-v2';
import {
  getCurrentProjectLinkData,
  getIsCurrentProjectPrivate,
} from 'src/selectors/project-selectors';
import { useProjectNavigationProps } from './use-project-navigation-props';

type ProjectNavigationProps = RouteComponentProps & {
  children: React.ReactNode;
  isBeingRenderedInsideMobileNav: boolean;
  menuItems: MenuItem[];
  selectedMenuItem: MenuItem | undefined;
};

export const ProjectNavigation = React.memo((props: ProjectNavigationProps) => {
  const appData = useAppData();
  const { isNavigationResourceSwitchEnabled } =
    getRouteFeaturesFromAppData(appData);
  const navigationData = useNavigationData();

  const currentProjectLinkData = useSelector(
    getCurrentProjectLinkData,
    shallowEqual
  );
  const isCurrentProjectPrivate = useSelector(getIsCurrentProjectPrivate);

  const legacyNavigationData = useLegacyReduxNavigationData();

  const { name, links } = currentProjectLinkData;
  const htmlUrl = links?.html.href;
  const avatarUrl = links?.avatar.href;

  if (isNavigationResourceSwitchEnabled) {
    return (
      <Navigation
        {...navigationData}
        isBeingRenderedInsideMobileNav={props.isBeingRenderedInsideMobileNav}
        isGlobalContext={false}
        navigationType="container"
        useContainerNavigationProps={useContainerNavigationProps}
      >
        {props.children}
      </Navigation>
    );
  }

  return (
    <Navigation
      {...legacyNavigationData}
      isBeingRenderedInsideMobileNav={props.isBeingRenderedInsideMobileNav}
      containerName={name}
      containerHref={htmlUrl}
      containerLogo={avatarUrl}
      isGlobalContext={false}
      isPrivate={isCurrentProjectPrivate}
      navigationType="container"
      useContainerNavigationProps={useProjectNavigationProps}
    >
      {props.children}
    </Navigation>
  );
});
